export default __webpack_public_path__ + "static/bottle-man-e0a7aac1fc6464eed4b9b61912c281a5.png";